// extracted by mini-css-extract-plugin
module.exports = {"bms_item":"GlobalItem_bms_item__3FJfn","column_field":"GlobalItem_column_field__3g2_H","add_or_remove_button":"GlobalItem_add_or_remove_button__2YlZu"};